import * as React from "react";

export default function useModelState() {
  return React.useState<{ [key: string]: string[] }>({});
}
